import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={18}
            height={18}
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M7.138 6.61L3.85 3.323m0 11.049l3.311-3.312m4.448.025l3.287 3.287m0-11.049l-3.312 3.313m5.602 2.212a7.813 7.813 0 11-15.625 0 7.813 7.813 0 0115.626 0zm-4.687 0a3.125 3.125 0 11-6.25 0 3.125 3.125 0 016.25 0z"
                stroke={props.isHover ? '#fff' : theme["#0D968F"]}
                strokeWidth={1.5625}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
  
  export default SvgComponent